<template lang="pug">
b-container#page.promotions
  b-row
    .col-4
      //h1 {{ msg }}
      h2 Nueva promoción
      b-form(v-if="show" inline)
        b-form-group#input-counter-group(label='Counter:' description="¡Buenos dias!")
          b-form-input#input-counter.mr-sm-2(v-model="user.email" size='sm' placeholder='Usuario' disabled)
          b-button.my-2.my-sm-0(size='sm' type='submit') Salir
      h3(v-if="this.$cookies.get('role') == 'admin'") Datos de la promoción
      b-form(v-if="this.$cookies.get('role') == 'admin' && show" @submit='onSubmit' @reset='onReset')
        b-form-group#input-message-group(label='Descripción:' label-for='input-message')
          b-form-input#input-message(v-model='form.message' /*required=''*/ placeholder='Descripción de promoción')
        b-form-group#input-airlineCode-group(label='Código de aereolínea:' label-for='input-airlineCode')
          b-form-input#input-airlineCode(v-model='form.airlineCode' /*required=''*/ placeholder='Código de aereolínea')
        b-form-group#input-searchLocation-group(v-if="airports.length > 0 && editable" label='Buscar:' label-for='input-searchLocation' :disabled="!editable")
          vue-bootstrap-typeahead#input-searchLocation(v-model="form.searchLocation" :data="airports | readable " ref="searchLocation" :disabled="!editable")
        b-form-group#input-locationDate-group(v-if="editable" label='Fecha:' label-for='input-locationDate')
          b-form-datepicker#input-locationDate(v-model="form.locationDate" :disabled="!editable")
        b-form-group#input-locationTime-group(v-if="editable" label='Hora:' label-for='input-locationTime')
          b-form-timepicker#input-locationTime(v-model="form.locationTime" :disabled="!editable")
        b-form-group#locationsButtons(v-if="editable")
          b-button.mr-sm-2(type='button' variant='primary' v-on:click='addLocation()') Añadir
          b-button(type='reset' v-on:click='clearLocations()' variant='primary') Limpiar
        b-list-group
          b-list-group-item(v-for="(destination, index) in form.destinations" :key="destination.ICAO")
            b-button.btn-sm.ml-3.float-right(v-if="editable" type='reset' v-on:click='clearLocation(index)' variant='danger') Quitar
            p {{ destination.mensaje }}
            p.small {{ destination.date }} {{ destination.time }}
        b-form-group#input-startDate-group(label='Fecha de inicio:' label-for='input-startDate')
          b-form-datepicker#input-startDate(v-model="form.startDate")
        b-form-group#input-endDate-group(label='Fecha de fin:' label-for='input-endDate')
          b-form-datepicker#input-endDate(v-model="form.endDate")
        b-form-group#input-file-group(label='Archivo:' label-for='input-file')
          button#input-file(@click="openUploadModal('file')") Subir archivo
          cld-context(cloudName='p1nkx3l')
            cld-image(:publicId='form.file')
          //input(type="file" :disabled="!editable")
        b-form-group#input-currency-group(label='Tipo de moneda:' label-for='input-currency')
          b-form-select#input-currency(v-model='form.currency' required='' :options="currencies" placeholder='Tipo de moneda' :disabled="!editable")
        b-form-group#input-total-group(label='Total:' label-for='input-total' inline)
          b-form-input#input-total(v-model='form.total' required='' placeholder='Total' type="number"  :disabled="!editable")
        b-form-group#submit-group
          b-button.mr-sm-2(type='submit' variant='primary') Crear promoción
          b-button(type='reset' variant='primary') Limpiar
    .col-8
      h2 Promociones
      div
      b-card-group(columns='' /*v-if='!loading'*/)
        b-card.mt-3(
          :title="promotion.message"
          header-tag="header"
          footer-tag="footer"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
          v-for="promotion in promotions"
        )
          template(v-slot:header)
            h6(class="mb-0") {{ promotion.airlineCode }}
          b-card-text
            b-list-group
              b-list-group-item(v-for="(destination, index) in formatDestionations(promotion.routeGroup)" :key="destination.ICAO")
                //b-button.btn-sm.ml-3.float-right(v-if="editable" type='reset' v-on:click='clearLocation(index)' variant='danger') Quitar
                p {{ destination.mensaje }}
                p.small {{ destination.date }} {{ destination.time }}
              cld-context(cloudName='p1nkx3l')
                cld-image(:publicId='promotion.file')
          //b-button(v-if="!hideButtons" :to="{ name: 'Operation', params: { id: this.id } }" :variant="saleId ? 'secondary':'primary'") {{ saleId ? "Ver venta" : "Ver reserva"}}
          //b-button.ml-1(v-if="!saleId && !hideButtons" :to="{ name: 'Operation', params: { id: this.id } }" variant='secondary') Crear venta
          template(v-slot:footer)
            span {{ promotion.currency }} {{ promotion.total }}
          //pre {{ promotions }}
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { CldContext, CldImage } from "cloudinary-vue";

export default {
  name: "Promotions",
  /*props: {
    airports: Array,
  },*/
  components: {
    CldContext,
    CldImage,
  },
  computed: {
    ...mapState(["user", "airports", "promotions"]),
    ...mapGetters(["user", "airports", "promotions"]),
    editable() {
      return true; //this.input || this.isEditable;
    },
  },
  data() {
    return {
      form: {
        message: "",
        airlineCode: "",
        searchLocation: "",
        locationDate: "",
        locationTime: "",
        destinations: [],
        startDate: "",
        endDate: "",
        file: "",
        currency: "",
        total: "",
      },
      show: true,
      currencies: [
        { text: "", value: null },
        { text: "Nuevos soles [PEN]", value: "pen" },
        { text: "Dólares americanos [USD]", value: "usd" },
        { text: "Euro [EUR]", value: "eur" },
      ],
    };
  },
  filters: {
    readable: (array) => {
      return array.map((data) => {
        return (
          (data.IATA != "\\N" ? data.IATA + ", " : "") +
          data.city +
          ", " +
          data.country +
          ", " +
          data.name +
          ", " +
          data.ICAO
        );
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("getPromotions");
  },
  methods: {
    openUploadModal(attribute) {
      window.cloudinary
        .openUploadWidget(
          {
            cloud_name: "p1nkx3l",
            upload_preset: "ml_default",
          },
          (error, result) => {
            if (!error && result && result.event === "success") {
              console.log("Done uploading..: ", result.info);
              this.form[attribute] = result.info.public_id;
              //this.publicId = result.info.public_id;
            }
          }
        )
        .open();
    },
    addLocation() {
      this.form.destinations.push({
        ICAO: this.form.searchLocation.split(",").pop().trim(),
        mensaje: this.form.searchLocation,
        date: this.form.locationDate,
        time: this.form.locationTime,
      });
      //this.form.searchLocation = undefined;
      this.$refs.searchLocation.inputValue = "";
      this.form.locationDate = null;
      this.form.locationTime = null;
    },
    async onSubmit(evt) {
      evt.preventDefault();

      try {
        this.$store.dispatch("addPromotion", this.form);
      } catch (error) {
        console.log(error);
      } finally {
        console.log("promotionSubmited");
      }

      /*alert(this.form);
      this.$store.dispatch("addOperation", {
        clientId: {
          firstName: this.form.firstName,
        },
        passangerGroupID: {
          passengerNumber: this.form.passengerNumber,
        },
      });
      //this.$store.dispatch("loadItems");
      alert(JSON.stringify(this.form));*/
    },
    onReset(evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.email = "";
      this.form.message = "";
      this.form.airlineCode = "";
      this.form.searchLocation = "";
      this.form.locationDate = "";
      this.form.locationTime = "";
      this.form.destinations = [];
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.file = "";
      this.form.currency = "";
      this.form.total = "";

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    formatDestionations(routeGroup) {
      const destinations = routeGroup.map((destination) =>
        (({ ICAO, datetime }) => ({
          ICAO,
          mensaje: this.$options.filters
            .readable([
              this.airports.find((airport) => airport.ICAO == destination.ICAO),
            ])
            .pop(),
          date: datetime.split("T")[0],
          time: datetime.split("T")[1].split(".")[0],
        }))(destination)
      );

      return destinations;
    },
  },
};
</script>

<style scoped lang="stylus">
ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.card-group > div {
  width: 100%;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 2;
  }

}
</style>
